module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "dropcap1"
  }, [_c('em', [_vm._v("C")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 2")])]), _c('br'), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('em', [_vm._v("W")])]), _vm._v("illiam saw Marcail step forward, her slight body breaking his fall just before he landed on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Why has she drugged me?")]), _vm._v(" He was too numb to feel anything, his emotions as muted as his body. He watched with unemotional interest as she eased him to the floor and then made a pillow of his cloak and placed it under his head, her hands careful and sure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, ever so gently, she slipped the chain from around his neck and went to his desk. The lowering sunlight cast her in a golden glow that made her seem ethereal, an angel of such purity, beauty, and exquisite grace that it pained him to watch her.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("It was that grace that had won him in the first ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("place. Not her face nor her figure nor her rich voice, all of which had helped catapult her to fame. When she walked, she drew a man’s attention and held it, almost as if she were dancing to music that only she could hear.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Her dark hair gleamed in the lingering light as she unlocked his desk and reached in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("How much gold was in the cubbyhole? Two hundred guineas? Three? I’ll have to check the records once she leaves, the little thief. But why does she need it? Does she have debts she can’t tell her protector about?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She straightened, and in her hand was the velvet bag holding the ancient artifact William needed to ransom his brother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even in his drugged state, fury trickled through. "), _c('em', [_vm._v("I must have that artifact. I cannot free Michael without it!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She tugged open the bag and glanced inside, her brows lowering as she slid the slender onyx box free. She traced the tip of a finger over the edge of the box, her expression perplexed. Uncertain, she glanced his way and met his gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her cheeks darkened as if she blushed, and she hurriedly tucked the artifact away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("William wanted to revile her, to cut her to shreds, but all he could do was glare at her with all of the force of his anger, which was burning through the drug’s haze.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("He tried with all of his strength to move and his ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("toes curled, which had been impossible just two moments ago. "), _c('em', [_vm._v("The drug is already wearing off! Woe betide the wench soon")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Even if he had to crawl on his hands and knees, he’d teach her a lesson she wouldn’t forget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She tied her cloak about her neck, then slid the box into a deep pocket. “I hate to leave you upon the floor, but I must.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He ground his teeth and glared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She paused at his side and, with an almost regretful look, she stooped and placed a hand upon his cheek. Her gaze was bright, as if with unshed tears. “Don’t try to follow me, William. You won’t be able to reach me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But he "), _c('em', [_vm._v("would")]), _vm._v(" reach her. Even if it took him the rest of his life, he’d exact a vengeance so harsh, so cold—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She bent over him, her long, silky hair sweeping over his cheek in a gossamer caress, the faint scent of her exotic perfume making his heart pound faster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am sorry to do this, "), _c('em', [_vm._v("mon cher")]), _vm._v(", but I have no choice.” She brushed her soft lips over his, the kiss as gentle as sea mist. Then, in a voice tinged with remorse, she said, “To you, this is a trinket. To me, it is freedom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With that cryptic statement, she rose and pulled her hood over her head, tucking her hair out of sight. “I knew you wouldn’t help, so this was my only recourse. I did give you a chance beforehand.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("She stepped toward the door, but William’s fingers had closed about her hem. He held tightly to the skirt, his gaze blazing. Once he was free of this drug, he’d teach her the danger of crossing him.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good-bye, William.” She yanked her skirt from his grasp and crossed to the doorway. There, she looked back. “I know you won’t believe me, but I wish you well. I always have.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She left the cabin, quietly closing the door behind her, leaving William in the growing darkness.")])]), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "noindentb"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('em', [_vm._v("A letter from Mary Hurst to her brother Michael as he prepared for his first expedition")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I hesitate to mention this, as I know you’re quite busy with your preparations, but I am worried about William. Since he came back from sea he’s so quiet, solemn, and—I think—sad. I asked him what was wrong, and he laughed bitterly and said he’d learned an important lesson.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wonder if perhaps he fell in love and it didn’t prosper?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mother is certain he will overcome whatever is bothering him, though she has been taking special pains to tempt his appetite. I think that it will take much more than rabbit stew to heal a truly broken heart.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f5415ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 90
// module chunks = 0